module.exports = __webpack_public_path__ + "static/img/7en.71e19e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/7en.png
// module id = /DuS
// module chunks = 0